import { MessageData, parseMessageData } from '../lib/message';
import { PaymentMessage } from '../types/message';

const MessageSources = ['YandexTrustPaymentForm', 'YandexTrustBindingForm', 'YandexTrustTokenizeForm'];

export const getPaymentMessage = (messageData: MessageData) => {
    const data = parseMessageData<PaymentMessage>(messageData);

    return MessageSources.includes(data?.source) ? (data as PaymentMessage) : { type: '', source: '', data: {} };
};
